import { css } from '@emotion/css'

const styles = {
  optionalText: css({
    color: '#5c5c5c',
    fontSize: '16px',
  }),
}

export default styles
